import React from "react";

interface Props {
  size?: number;
  className?: string;
}

/** ALTRUIST project logo — globe with satellite orbits and tsunami wave */
function AltruistLogo({ size = 36, className = "" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Globe */}
      <circle cx="32" cy="32" r="22" stroke="#0ea5e9" strokeWidth="2.2" fill="#f0f7ff" />
      {/* Meridian */}
      <ellipse cx="32" cy="32" rx="10" ry="22" stroke="#0ea5e9" strokeWidth="1.2" opacity="0.5" />
      {/* Equator */}
      <ellipse cx="32" cy="32" rx="22" ry="7" stroke="#0ea5e9" strokeWidth="1.2" opacity="0.5" />

      {/* Satellite orbit 1 — tilted arc */}
      <path
        d="M 10 18 Q 32 2, 54 18"
        stroke="#6366f1"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.7"
      />
      {/* Satellite dot on orbit 1 */}
      <circle cx="50" cy="17" r="2.5" fill="#6366f1" />

      {/* Satellite orbit 2 — second tilted arc */}
      <path
        d="M 8 28 Q 30 10, 56 26"
        stroke="#f59e0b"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
      {/* Satellite dot on orbit 2 */}
      <circle cx="12" cy="27" r="2.5" fill="#f59e0b" />

      {/* IPP track — dashed arc on the globe */}
      <path
        d="M 20 30 Q 32 22, 44 30"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="2 2.5"
        fill="none"
        opacity="0.8"
      />

      {/* Tsunami wave — bottom of globe */}
      <path
        d="M 14 44 C 18 40, 22 48, 26 44 C 30 40, 34 48, 38 44 C 42 40, 46 48, 50 44"
        stroke="#1a8aab"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Second wave (smaller) */}
      <path
        d="M 18 49 C 21 46, 24 52, 27 49 C 30 46, 33 52, 36 49 C 39 46, 42 52, 46 49"
        stroke="#1a8aab"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.5"
      />
    </svg>
  );
}

export default AltruistLogo;
